export const getApiBaseUrl = () => import.meta.env.VITE_API_BASE_URL;